const platformItems = [
  { name: '香蕉视频', desc: '海量高清影视，每日更新热门大片与综艺', icon: 'ri-movie-2-line', color: 'bg-primary-500' },
  { name: '红桃视频', desc: '独家自制内容，精选综艺节目与纪录片资源', icon: 'ri-tv-2-line', color: 'bg-accent-500' },
  { name: '91视频', desc: '原创社区平台，多元化短视频与UGC内容', icon: 'ri-user-smile-line', color: 'bg-primary-500' },
  { name: '蜜桃视频', desc: '海量影视剧集资源库，支持超清流畅播放', icon: 'ri-clapperboard-line', color: 'bg-secondary-500' },
  { name: '西瓜视频', desc: '智能推荐算法，个性化发现专属视频内容', icon: 'ri-lightbulb-flash-line', color: 'bg-accent-500' },
  { name: '樱花视频', desc: '日韩影视专区，精选字幕组精译海外作品', icon: 'ri-flower-line', color: 'bg-primary-500' },
  { name: '糖豆视频', desc: '轻量级短视频平台，碎片化娱乐消遣之选', icon: 'ri-emotion-happy-line', color: 'bg-secondary-500' },
  { name: '更多平台', desc: '持续收录更多优质视频平台，敬请期待更新', icon: 'ri-add-circle-line', color: 'bg-foreground-400' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">视频平台大全</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            一站式浏览当前热门的在线视频平台入口，快速找到你想要的视频网站
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {platformItems.map((item, i) => (
            <div
              key={i}
              className="group p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-100/50 transition-all cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-lg ${item.color} flex items-center justify-center mb-3`}>
                <i className={`${item.icon} text-lg text-background-50`}></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
                {item.name}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}